import { useEffect, useState } from 'react';
import { ory } from 'src/auth/ory';
import { Logger } from 'src/utils/Logger';

type AuthCheckState = 'loading' | 'new_invite' | 'existing_user' | 'no_flow';

export const useAuthMethodCheck = (flowId: string | null): AuthCheckState => {
  const [state, setState] = useState<AuthCheckState>('loading');

  useEffect(() => {
    if (!flowId) {
      setState('no_flow');
      return;
    }

    const checkAuthMethod = async () => {
      try {
        const { data: session } = await ory.toSession();
        const authMethods = session.authentication_methods ?? [];
        const mostRecentMethod = authMethods[authMethods.length - 1]?.method;

        if (mostRecentMethod === 'link_recovery') {
          setState('new_invite');
        } else {
          setState('existing_user');
        }
      } catch (error) {
        Logger.error('Failed to check auth method, assuming new invite', error);
        setState('new_invite');
      }
    };

    checkAuthMethod();
  }, [flowId]);

  return state;
};
